// @ts-nocheck
/**
 * Generated by orval v7.4.1 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { GenericApiResponseRubricPromptDataData } from './genericApiResponseRubricPromptDataData';
import type { GenericApiResponseRubricPromptDataMessage } from './genericApiResponseRubricPromptDataMessage';
import type { GenericApiResponseRubricPromptDataPagination } from './genericApiResponseRubricPromptDataPagination';
import type { GenericApiResponseRubricPromptDataError } from './genericApiResponseRubricPromptDataError';

export interface GenericApiResponseRubricPromptData {
  data?: GenericApiResponseRubricPromptDataData;
  message?: GenericApiResponseRubricPromptDataMessage;
  pagination?: GenericApiResponseRubricPromptDataPagination;
  error?: GenericApiResponseRubricPromptDataError;
  statusCode?: number;
}
